import { useTranslation } from 'react-i18next'
import { DRIVLINJE_OPTIONS, START_CLASS_OPTIONS, SLUTTKUNDE_OPTIONS } from './api'
import { ChipGroup } from './FilterChip'

export interface StaatidLocalFilters {
  antallTransfers: number[]
  startClass: string[]
  sluttkundeType: string[]
  drivstoffGruppe: string[]
}

export const EMPTY_LOCAL_FILTERS: StaatidLocalFilters = {
  antallTransfers: [],
  startClass: [],
  sluttkundeType: [],
  drivstoffGruppe: [],
}

interface Props {
  /** The draft the chips render — owned by the layout's filter box (#526). */
  value: StaatidLocalFilters
  onChange: (next: StaatidLocalFilters) => void
}

const ANTALL_OPTIONS = [
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5+' },
] as const

/**
 * Ståtid-specific filter bar: antall ledd, innkjøpstype (start_class),
 * sluttkunde-type and drivlinje (#800).
 *
 * Controlled (#526). It used to own its draft and carry its own "Vis
 * resultater" / "Nullstill" pair, which made it a second commit point on a tab
 * that already has the layout's. Its Nullstill also reset to EMPTY and fired
 * immediately — both contrary to the semantics the rest of the module now
 * follows. The chips write to the layout's draft; the layout's Oppdater
 * commits them.
 */
export default function StaatidFilterBar({ value, onChange }: Props) {
  const { t } = useTranslation('staatid')
  return (
    <div data-testid="staatid-filter-bar" className="flex flex-wrap gap-x-6 gap-y-3 items-end">
      <ChipGroup
        label={t('filter.antallLedd')}
        options={ANTALL_OPTIONS}
        selected={value.antallTransfers}
        onChange={antallTransfers => onChange({ ...value, antallTransfers })}
      />
      <ChipGroup
        label={t('filter.innkjopstype')}
        options={START_CLASS_OPTIONS.map(o => ({ value: o.value, label: t(o.labelKey) }))}
        selected={value.startClass}
        onChange={startClass => onChange({ ...value, startClass })}
      />
      <ChipGroup
        label={t('filter.sluttkunde')}
        options={SLUTTKUNDE_OPTIONS.map(o => ({ value: o.value, label: t(o.labelKey) }))}
        selected={value.sluttkundeType}
        onChange={sluttkundeType => onChange({ ...value, sluttkundeType })}
      />
      <ChipGroup
        label={t('filter.drivlinje')}
        options={DRIVLINJE_OPTIONS.map(o => ({ value: o.value, label: t(o.labelKey) }))}
        selected={value.drivstoffGruppe}
        onChange={drivstoffGruppe => onChange({ ...value, drivstoffGruppe })}
      />
    </div>
  )
}
